import { FC, ReactNode } from 'react';
import Bildfil from './Bildfil';
import { ContentResponse } from '../types/shared';
import { ContentTypeGuid } from '../types/enums';

interface IContentImageProps {
  contentResponse: ContentResponse;
}

const ContentImage: FC<IContentImageProps> = ({ contentResponse }): ReactNode => {
  const renderContentImage = () => {
    switch (contentResponse.contentTypeGuid) {
      case ContentTypeGuid.Bildfil:
        return <Bildfil contentResponse={contentResponse} />;
      default:
        console.warn(`Renderingsimplementation saknas för Image med contentTypeGuid: ${contentResponse.contentTypeGuid}`);
        return <></>;
    }
  };

  return (
    <>
      {renderContentImage()}
    </>
  );
};

export default ContentImage;
